import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useInfluencerTickers() {
  return useQuery({
    queryKey: ["influencer-tickers"],
    queryFn: async () => {
      const map = new Map<string, Set<string>>();
      const PAGE_SIZE = 1000;
      let offset = 0;
      let hasMore = true;

      while (hasMore) {
        const { data, error } = await supabase
          .from("x_calls")
          .select("x_user_id, asset")
          .in("action", ["BUY", "SHORT"])
          .range(offset, offset + PAGE_SIZE - 1);
        if (error) throw error;

        for (const row of data || []) {
          if (!map.has(row.x_user_id)) map.set(row.x_user_id, new Set());
          map.get(row.x_user_id)!.add(row.asset.toUpperCase());
        }

        hasMore = (data?.length ?? 0) === PAGE_SIZE;
        offset += PAGE_SIZE;
      }

      return map;
    },
    staleTime: 5 * 60 * 1000,
  });
}
